export class LocationMaster {
    public ID!: number;
    public LOC_CODE!: string;
    public LOC_NAME!: string;
    public LOC_ADD1!: string;
    public LOC_ADD2!: string;
    public ISDEFAULT!: Boolean;
    public LOC_PUBLISH!: number;
    public LOC_ORDER!: number;
    public OPENING_AMT!: number;
    public OPENING_DATE!: Date;
    public LEDGER_NAME!: string;
    public LABOUR_LEDGER!: string;
    public BILL_LOC!: Boolean;
    public OFE_LEDGER!: string;
    public ORM_LEDGER!: string;
    public SW_LEDGER!: string;
    public PS_LEDGER!: string;
    public BANK_ID!: number;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: Date;
    public UPDATED_DATE!: Date;
    public IS_ACTIVE!: Boolean;
}